import React from 'react';

import get from 'lodash/get';
import formatDate from 'date-fns/format';
import { injectIntl, defineMessages } from 'react-intl';

import './styles.css';
import { ReactComponent as AddToMyTransferPlannerSvg } from './add-to-transfer-planner.svg';

const messages = defineMessages({
  addToMyTransferPlan: {
    id: 'hubs.transfer.application-deadlines.add-to-transfer-plan',
    defaultMessage: 'Add to my Transfer Planner',
  },
});

export function formatMonth(month) {
  if (month) {
    return formatDate(new Date(2000, month - 1, 1), 'MMMM');
  }
  return null;
}

function ApplicationDeadlines({ intl, deadlines, addToTransferPlan }) {
  const addDeadlineToTransferPlan = React.useCallback(
    (deadline) => (e) => {
      addToTransferPlan(e, deadline.description);
    },
    [addToTransferPlan],
  );

  return (
    <div name="application-deadlines" className="section-text ">
      {deadlines.map((deadline, idx) => {
        const day = Number(get(deadline, 'day'));
        const description = get(deadline, 'description');
        const month = formatMonth(Number(get(deadline, 'month')));

        return day && month ? (
          <div className="deadline-card" key={`deadline${idx}`}>
            <div>
              <span>{month}</span>
              <span>{day}</span>
            </div>
            <p>{description}</p>
            <div>
              <span>{intl.formatMessage(messages.addToMyTransferPlan)}</span>
              <button onClick={addDeadlineToTransferPlan(deadline)}>
                <AddToMyTransferPlannerSvg />
              </button>
            </div>
          </div>
        ) : null;
      })}
    </div>
  );
}

export default injectIntl(ApplicationDeadlines);
